/**
 * Registration subdivisions (`EntityRegistration.subdivision`, KYB routing).
 *
 * `<country>-<code>`: ISO 3166-2 (`CA-QC`, `US-DE`) or, for the UAE, a free
 * zone with its own registry (`AE-DMCC`). The backend checks the format, not a
 * closed list (`apps/companies/subdivisions.py`); these are suggestions for
 * the corridor countries. Codes are data, not interface text.
 */
const SUGGESTIONS: Record<string, readonly string[]> = {
  CA: [
    "CA-QC",
    "CA-ON",
    "CA-BC",
    "CA-AB",
    "CA-MB",
    "CA-SK",
    "CA-NS",
    "CA-NB",
    "CA-NL",
    "CA-PE",
    "CA-YT",
    "CA-NT",
    "CA-NU",
  ],
  AE: [
    "AE-DU",
    "AE-AZ",
    "AE-SH",
    "AE-AJ",
    "AE-RK",
    "AE-FU",
    "AE-UQ",
    "AE-DMCC",
    "AE-DIFC",
    "AE-ADGM",
    "AE-JAFZA",
    "AE-DAFZA",
    "AE-DSO",
    "AE-IFZA",
    "AE-RAKEZ",
    "AE-SAIF",
    "AE-SHAMS",
    "AE-KIZAD",
  ],
  US: ["US-DE", "US-NY", "US-CA", "US-TX", "US-FL", "US-NV", "US-WY"],
};

export function subdivisionSuggestions(country: string): readonly string[] {
  return SUGGESTIONS[(country || "").toUpperCase()] ?? [];
}

/** Same normalisation as the backend: trim, upper-case, `_` → `-`. */
export function normaliseSubdivision(value: string): string {
  return value.trim().toUpperCase().replace(/_/g, "-");
}
